import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const EMAIL_TEMPLATES_EMAIL_TEMPLATE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/email-templates',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:EmailTemplates',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.EmailTemplates',
      },
    ]);
  };
}
